<air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
<div [internalInnerHtml]="content.description" [userEventSource]="userEventSource"></div>

<!-- transfer methods section -->
<ng-container *ngIf="canTransferPoints">
  <div [internalInnerHtml]="content.transferDescription" [userEventSource]="userEventSource"></div>
  <div class="interactive-block form">
    <h3>{{ "terminate_account.transfer.title" | translate }}</h3>
    <div class="button__group">
      <!-- charity button -->
      <ng-container
        [ngTemplateOutlet]="donationMethodButton"
        [ngTemplateOutletContext]="{
          type: 'charity',
          label: 'terminate_account.transfer.options.charity.button' | translate
        }"
      ></ng-container>
      <!-- transfer button -->
      <ng-container
        [ngTemplateOutlet]="donationMethodButton"
        [ngTemplateOutletContext]="{
          type: 'user',
          label: 'terminate_account.transfer.options.user.button' | translate
        }"
      ></ng-container>
      <!-- nobody button -->
      <ng-container
        [ngTemplateOutlet]="donationMethodButton"
        [ngTemplateOutletContext]="{
          type: 'nobody',
          label: 'terminate_account.transfer.options.nobody.button' | translate
        }"
      ></ng-container>
    </div>
    <!-- charity -->
    <div class="form-group" [hidden]="donationMethodType !== donationMethod.charity">
      <div class="organizations" *ngIf="!loading && charityProducts" [formGroup]="pickerForm">
        <label
          *ngFor="let charity of charityProducts"
          [title]="charity.title"
          class="organizations__box"
          [ngClass]="{
            active: charityId.value === charity.id
          }"
        >
          <div class="button button--primary">
            <i class="icon icon-ui-checkmark--sm"></i>
          </div>
          <input
            type="radio"
            [formControl]="charityId"
            formControlName="charityId"
            name="charityId"
            [value]="charity.id"
            (change)="onCharityChange(charity.title)"
          />
          <img *ngIf="charity.logo" [src]="charity.logo.cropUrl" [alt]="charity.title" />
        </label>
      </div>
    </div>
    <!-- user -->
    <div class="form-group" [hidden]="donationMethodType !== donationMethod.user">
      <!-- transfer points section -->
      <div class="form">
        <h3>{{ "terminate_account.transfer.options.user.header" | translate }}</h3>
        <div class="button__group">
          <ng-container
            [ngTemplateOutlet]="transferMethodButton"
            [ngTemplateOutletContext]="{
              type: 'emailAddress',
              label: 'account.label.email' | translate
            }"
          ></ng-container>
          <!-- card number button -->
          <ng-container
            [ngTemplateOutlet]="transferMethodButton"
            [ngTemplateOutletContext]="{
              type: 'cardNumber',
              label: 'account.label.card_number' | translate
            }"
          ></ng-container>
        </div>
        <div class="form-group" [hidden]="transferMethodType !== transferMethod.emailAddress">
          <label
            for="transfer-method--email-address"
            [ngClass]="{
              'form-label--error': emailAddress.dirty && emailAddress.invalid
            }"
          >
            {{ "transfer_points.transfer_method.label.email" | translate }}
          </label>
          <input [formControl]="emailAddress" type="email" id="transfer-method--email-address" />
          <div class="form-error" *ngIf="emailAddress.dirty && emailAddress.invalid">
            <div *ngIf="emailAddress.hasError('email')" class="form-error__message">{{ "account.error.email.invalid" | translate }}</div>
            <div *ngIf="emailAddress.hasError('required')" class="form-error__message">
              {{ "account.error.email.required" | translate }}
            </div>
          </div>
        </div>
        <!-- card number input field -->
        <div class="form-group" [hidden]="transferMethodType !== transferMethod.cardNumber">
          <label
            for="transfer-method--card-number"
            [ngClass]="{
              'form-label--error': cardNumber.dirty && cardNumber.invalid
            }"
          >
            {{ "transfer_points.transfer_method.label.card" | translate }}
          </label>
          <input [formControl]="cardNumber" type="text" id="transfer-method--card-number" />
          <div class="form-error" *ngIf="cardNumber.dirty && cardNumber.invalid">
            <div *ngIf="cardNumber.hasError('pattern')" class="form-error__message">
              {{ "account.error.card_number.invalid" | translate }}
            </div>
            <div *ngIf="cardNumber.hasError('required')" class="form-error__message">
              {{ "account.error.card_number.required" | translate }}
            </div>
          </div>
          <small class="form__description">{{ "account.description.card_number" | translate }}</small>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- submit button -->
<button
  type="button"
  class="button form__button button--full-width button--cta"
  [disabled]="formDisabled"
  [airButtonLoading]="isSubmitting"
  (click)="submit($event)"
>
  <span>{{ "terminate_account.submit.btn_label" | translate }}</span>
</button>

<ng-template #donationMethodButton let-type="type" let-label="label">
  <div
    role="button"
    class="button"
    [ngClass]="{
      'button--primary': donationMethodType === type,
      'button--border': donationMethodType !== type
    }"
    (click)="setDonationMethodType(type, $event)"
  >
    <span>{{ label }}</span>
  </div>
</ng-template>

<ng-template #transferMethodButton let-type="type" let-label="label">
  <div
    role="button"
    class="button"
    [ngClass]="{
      'button--primary': transferMethodType === type,
      'button--border': transferMethodType !== type
    }"
    (click)="setTransferMethodType(type, $event)"
  >
    <span>{{ label }}</span>
  </div>
</ng-template>
